/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 */

import type { Origin } from '@zcode/nr-utils'

import type { receiveData } from '../../../modals/actions/saveSearchModal'

export type SaveSearchOrigin = Origin | Parameters<typeof receiveData>[0]['origin']

export function getOrigin({ origin, isMobile }: { isMobile: boolean; origin: SaveSearchOrigin }) {
  if (isMobile && !origin.includes('m.')) {
    return `m.${origin}` as const
  }

  return origin
}
